import React from 'react';

import { Box, Typography } from '@mui/material';
import { Navigate } from 'react-router';

import { useAuthCredentials } from '@hrlogics/react-auth';

import { appRoutes } from '@clearverify/constants';

import {
  MfaLoginForm,
  MfaVerificationCodeForm,
} from 'src/components/account/SetupMfaPageContent/components';
import { AuthPaperBox } from 'src/components/auth';
import { FullscreenLoader } from 'src/components/common';
import { useCurrentUserAuthStatus } from 'src/hooks/auth';
import type { SxProp } from 'src/types/mui';

export const SetupMfaPageContent: React.FC = () => {
  const { accessToken } = useAuthCredentials();
  const { isMfaRequired, isMfaEnabled, loading } = useCurrentUserAuthStatus();

  // For the case when we open the form already authorized
  const [isImmediateVerification, setIsImmediateVerification] = React.useState(true);

  const handleLoginAction = React.useCallback(() => {
    setIsImmediateVerification(false);
  }, []);

  if (loading) {
    return <FullscreenLoader />;
  }

  if (isMfaEnabled) {
    return <Navigate to={appRoutes.root} />;
  }

  const renderForms = () => {
    if (!accessToken) {
      return (
        <MfaLoginForm
          handleLoginAction={handleLoginAction}
          isAuthRoute
          isMfaRequired={isMfaRequired}
        />
      );
    }
    return (
      <MfaVerificationCodeForm
        isImmediateVerification={isImmediateVerification}
        isAuthRoute
        isMfaRequired={isMfaRequired}
      />
    );
  };

  return (
    <AuthPaperBox sx={containerStyles}>
      <Typography variant="h5">Multi-factor Authentication</Typography>
      <Box mt={1}>{renderForms()}</Box>
    </AuthPaperBox>
  );
};

const containerStyles: SxProp = {
  maxWidth: 640,
};
